import React, { useEffect, useState } from "react";
import { Apple, Play } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Renders "Download on the App Store" / "Get it on Google Play" badges.
 * Reads the public /settings/app-links endpoint — a badge only shows when Ashley has
 * entered its link AND switched it on. Renders nothing when both are off.
 */
export function AppBadges({ className = "", size = "md", label, align = "start" }) {
  const [links, setLinks] = useState(null);
  useEffect(() => {
    api.get("/settings/app-links").then((r) => setLinks(r.data)).catch(() => setLinks({ apple: "", google: "" }));
  }, []);

  if (!links || (!links.apple && !links.google)) return null;

  const pad = size === "sm" ? "px-3.5 py-1.5" : "px-4 py-2.5";
  const main = size === "sm" ? "text-sm" : "text-[17px]";
  const icon = size === "sm" ? "w-5 h-5" : "w-6 h-6";

  const Badge = ({ href, Icon, top, name, testid }) => (
    <a href={href} data-testid={testid} target="_blank" rel="noopener noreferrer"
      className={`inline-flex items-center gap-2.5 rounded-xl bg-black border border-white/15 hover:border-violet-400/70 text-white transition-colors ${pad}`}>
      <Icon className={icon} />
      <span className="flex flex-col leading-tight text-left">
        <span className="text-[10px] text-slate-300">{top}</span>
        <span className={`font-semibold ${main}`}>{name}</span>
      </span>
    </a>
  );

  return (
    <div className={className} data-testid="app-badges">
      {label && <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">{label}</p>}
      <div className={`flex flex-wrap gap-3 ${align === "center" ? "justify-center" : ""}`}>
        {links.apple && <Badge href={links.apple} Icon={Apple} top="Download on the" name="App Store" testid="badge-apple" />}
        {links.google && <Badge href={links.google} Icon={Play} top="GET IT ON" name="Google Play" testid="badge-google" />}
      </div>
    </div>
  );
}

export default AppBadges;
